if (!customElements.get('sv-collection-filter')) {
  customElements.define('sv-collection-filter', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.primary !== 'true') return;
      this.abort?.abort(); this.abort = new AbortController();
      this.path = this.dataset.allUrl; this.params = new URLSearchParams(location.search);
      this.params.delete('preview_theme_id'); this.params.delete('_fd'); this.params.delete('pb');
      window.svCollectionFilter = this;
      const opts = { signal: this.abort.signal, capture: true };
      document.addEventListener('click', event => {
        if (event.button || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const category = event.target.closest('[data-sv-category]');
        if (category) {
          event.preventDefault(); event.stopImmediatePropagation();
          const params = new URLSearchParams();
          if (this.params.has('sort_by')) params.set('sort_by', this.params.get('sort_by'));
          this.render(params.toString(), null, new URL(category.href).pathname);
          return;
        }
        const pagination = event.target.closest('#ProductGridContainer .pagination a');
        if (pagination) {
          event.preventDefault(); event.stopImmediatePropagation();
          this.render(new URL(pagination.href).search.slice(1), null, this.path, true);
        }
        const retry = event.target.closest('[data-sv-filter-retry]');
        if (retry && this.failed) this.render(...this.failed);
      }, opts);
      document.addEventListener('keydown', event => {
        if (event.key === ' ' && event.target.matches('[data-sv-category]')) { event.preventDefault(); event.target.click(); }
      }, { signal: this.abort.signal });
      this.sync();
    }
    disconnectedCallback() {
      this.abort?.abort(); this.fetchAbort?.abort();
      if (window.svCollectionFilter === this) delete window.svCollectionFilter;
    }
    sync() {
      document.querySelectorAll('[data-sv-category]').forEach(link => {
        const active = new URL(link.href).pathname === this.path;
        link.classList.toggle('sv-coll-filter__chip--active', active);
        link.setAttribute('aria-pressed', String(active)); link.setAttribute('role', 'button');
      });
    }
    async render(searchParams, event, path = this.path, scroll = false) {
      this.fetchAbort?.abort(); const abort = this.fetchAbort = new AbortController();
      const grid = document.getElementById('ProductGridContainer');
      const status = this.querySelector('[data-sv-filter-status]');
      const setStatus = text => {
        status.textContent = text;
        document.querySelectorAll('[data-sv-mobile-filter-status]').forEach(el => { el.textContent = text; });
      };
      const setRetry = hidden => document.querySelectorAll('[data-sv-filter-retry]').forEach(el => { el.hidden = hidden; });
      const section = document.getElementById('product-grid')?.dataset.id;
      const params = new URLSearchParams(searchParams); params.delete('section_id');
      const url = new URL(path, location.origin); url.search = params.toString(); url.searchParams.set('section_id', section);
      grid.setAttribute('aria-busy', 'true'); setStatus(this.dataset.loading); setRetry(true);
      try {
        const response = await fetch(url, { signal: abort.signal });
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        if (!doc.getElementById('ProductGridContainer') || !doc.getElementById('product-grid')) throw new Error('Missing product grid');
        if (abort.signal.aborted) return;
        FacetFiltersForm.renderSection(html, event);
        this.path = path; this.params = params; this.failed = null;
        const source = doc.querySelector('[data-sv-collection-summary]');
        setStatus(source?.textContent.trim() || this.dataset.loaded);
        const facets = document.querySelector('.facets-container'), newFacets = doc.querySelector('.facets-container');
        if (facets && newFacets) Object.assign(facets.dataset, newFacets.dataset);
        this.sync();
        if (scroll) { grid.setAttribute('tabindex', '-1'); grid.focus({ preventScroll: true }); grid.scrollIntoView({ block: 'start', behavior: 'instant' }); }
      } catch (error) {
        if (error.name === 'AbortError') return;
        this.failed = [searchParams, null, path, scroll];
        setStatus(this.dataset.error); setRetry(false);
      } finally {
        if (!abort.signal.aborted) {
          grid.removeAttribute('aria-busy');
          FacetFiltersForm.toggleActiveFacets(false);
          document.querySelectorAll('.facets-container .loading__spinner, facet-filters-form .loading__spinner').forEach(el => el.classList.add('hidden'));
        }
      }
    }
  });
}
